/**
 * Companies
 */
waApp.controllers.BuildingOfTheYear = {
	index: function() {
		$('.vote-form').each(function() {
			let buildingId = $(this).data('building-id');

			$(this).validate({
				rules: {
					email: {
						required: true,
						email: true,
						remote: {
							url: '/' + waApp.getLanguage() + '/building-of-the-year/email-has-voted',
							type: 'post',
							data: {
								email: function() {
									return $('#email-' + buildingId).val();
								},
								review_id: buildingId
							}
						},
					}
				},
				messages: {
					email: {
						remote: 'This email has already voted.'
					}
				},
				submitHandler: function(form) {
					form.submit();
				}
			});
		});

		$('.buildings-row').on('click', '.vote-btn', function(event) {
			event.preventDefault();

			let element = $(this).closest('.col-md-6');
			element.find('.vote-form-wrapper').removeClass('hidden');
			element.find('.fa-times').removeClass('hidden');
			element.find('.building-info').addClass('hidden');
		});

		$('.vote-form-wrapper').on('click', '.cancel-btn', function(event) {
			event.preventDefault();

			let element = $(this).closest('.col-md-6');
			element.find('.vote-form-wrapper').addClass('hidden');
			element.find('.fa-times').addClass('hidden');
			element.find('.building-info').removeClass('hidden');
		});

		$('.buildings-row').on('click', '.fa-times', function(event) {
			event.preventDefault();

			let element = $(this).closest('.col-md-6');
			element.find('.vote-form-wrapper').addClass('hidden');
			element.find('.fa-times').addClass('hidden');
			element.find('.building-info').removeClass('hidden');
		});

		$('.vote-form-wrapper').on('submit', 'form', function(event) {
			event.preventDefault();
		});
	},
};
